import React from 'external/react';

export const PropertyTd = ({ children }) => <td className="change-records-table__first-col">{children}</td>;
export const OldValueTd = ({ children }) => <td className="change-records-table__old-value">{children}</td>;
export const NewValueTd = ({ children }) => <td className="change-records-table__new-value">{children}</td>;



// WEBPACK FOOTER //
// ./js/components/ChangeRecords/TableElems.jsx